import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import { Link } from 'react-router';

import { getParentRouteURL } from 'utils/utils';
import smoothScroller from 'utils/smoothScroller';
import Immutable from 'immutable';

import './SubpageMasthead.scss';

export const baseClass = 'subpage-masthead';

export default class SubpageMasthead extends Component {
  static propTypes = {
    children: PropTypes.node,
    ctaType: PropTypes.oneOf(['back']),
    buttonContent: PropTypes.string,
    appState: PropTypes.object,
    location: PropTypes.object,
    btnOnClick: PropTypes.func,
    backUrl: PropTypes.string,
    customOnClick: PropTypes.func,
  };

  static defaultProps = {
    buttonContent: 'Done',
    appState: Immutable.Map(),
  };

  componentDidMount() {
    smoothScroller.scrollStraightToTop();
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  onClickHandler = (event) => {
    event.preventDefault();
    this.props.customOnClick(event);
  };

  render() {
    const { children, ctaType, backUrl, customOnClick } = this.props;
    let buttonClassName = `${baseClass}__button`;
    let buttonContent;

    if (ctaType === 'back') {
      buttonClassName = `${buttonClassName}--back`;
      buttonContent = (<i className="chevron-left-icon" />);
    } else {
      buttonContent = this.props.buttonContent;
    }

    return (
      <header className={`${baseClass}`}>
        {children && children.props ? (
          children
        ) : (
          <h1 className={`${baseClass}__title`}>{ children }</h1>
        )}

        {!this.props.appState.get('loadingState') && customOnClick ? (
          <a href="#" className={buttonClassName} onClick={this.onClickHandler}>
            { buttonContent }
          </a>
        ) : (
          <Link
            to={backUrl || getParentRouteURL(this.props.location)}
            onClick={this.props.btnOnClick}
            className={buttonClassName}
          >
            { buttonContent }
          </Link>
        )}
      </header>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SubpageMasthead/SubpageMasthead.jsx
 **/